import { CapturedPayload } from '../../models/CapturedPayload';
import { LogLevel } from '../../models/LogLevel';
import { AbstractTransporter } from '../AbstractTransporter';
import { TransportTemplate } from '../TransportTemplate';

/**
 * Default ConsoleTransporter template
 */
const defaultConsoleTransporterTemplate = <T>(p: CapturedPayload) => p.payload as T;
/**
 * Console transporter
 */
export class ConsoleTransporter<T> extends AbstractTransporter<T> {
    /**
     * @param template optional if not given, using default (no template, as message comes is written)
     */
    constructor(template?: TransportTemplate<T>) {
        super(template || defaultConsoleTransporterTemplate);
    }
    /**
     * writes payload in console
     */
    doWrite(payload: T, level: LogLevel): void {
        switch (level) {
            case LogLevel.Info:
                return console.info(payload);
            case LogLevel.Debug:
                return console.debug(payload);
            case LogLevel.Warn:
                return console.warn(payload);
            case LogLevel.Error:
                return console.error(payload);
        }
    }
}
